var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-settings-close"},[_c('el-button',{staticClass:"r-button icon-button",attrs:{"circle":""},on:{"click":_vm.clickHandler}},[_c('r-icon',{attrs:{"name":"close-delete","size":14}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }